import { render, staticRenderFns } from "./PartsDetail.vue?vue&type=template&id=c02caffa&scoped=true&"
import script from "./PartsDetail.vue?vue&type=script&lang=js&"
export * from "./PartsDetail.vue?vue&type=script&lang=js&"
import style0 from "./PartsDetail.vue?vue&type=style&index=0&id=c02caffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02caffa",
  null
  
)

export default component.exports